<template>
  <span class="rounded-full whitespace-no-wrap" :class="classes()">
    <div class="lds-ellipsis" v-if="loading">
      <div class="bg-gray-400"></div>
      <div class="bg-gray-400"></div>
      <div class="bg-gray-400"></div>
    </div>
    <span v-else v-text="text"></span>
  </span>
</template>

<script>
export default {
  props: {
    loading: {
      default: () => false
    },
    text: {},
    type: {
      default: () => "default"
    }
  },
  data() {
    return {
      types: {
        success: {
          textColor: "text-green-600",
          backgroundColor: "bg-green-100"
        },
        default: {
          textColor: "text-gray-700",
          backgroundColor: "bg-gray-200"
        },
        warning: {
          textColor: "text-yellow-600",
          backgroundColor: "bg-yellow-100"
        },
        info: {
          textColor: "text-blue-600",
          backgroundColor: "bg-blue-100"
        },
        danger: {
          textColor: "text-red-600",
          backgroundColor: "bg-red-100"
        }
      }
    };
  },
  methods: {
    classes() {
      return this.loading
        ? ["bg-gray-200"]
        : [
            this.types[this.type].textColor,
            this.types[this.type].backgroundColor
          ];
    }
  }
};
</script>

<style scoped>
@keyframes bouncing-loader {
  to {
    transform: translate3d(0, -1rem, 0);
  }
}

.bouncing-loader {
  display: flex;
  justify-content: center;
}

.bouncing-loader > div {
  width: 0.5rem;
  height: 0.5rem;
  margin: 0 0.2rem;
  background: #8385aa;
  border-radius: 50%;
  animation: bouncing-loader 0.6s infinite alternate;
}

.bouncing-loader > div:nth-child(2) {
  animation-delay: 0.2s;
}

.bouncing-loader > div:nth-child(3) {
  animation-delay: 0.4s;
}

.lds-ellipsis {
  display: flex;
  justify-content: center;
}

.lds-ellipsis div {
  width: 8px;
  height: 8px;
  margin: 0 0.2rem;
  border-radius: 50%;
  animation: ellipsis 1s infinite;
}

.lds-ellipsis > div:nth-child(2) {
  animation-delay: 0.2s;
}

.lds-ellipsis > div:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes ellipsis {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
